import {
  EndMarketLocations,
  FarmBoxCommodityDestribution,
} from 'models/FarmBoxCommodityDestribution/farmBoxCommodityDestribution.model';

export const stage5InitialData = async (
  commodityId: number,
  getCommodityDistribution: (
    commodityId: number
  ) => Promise<FarmBoxCommodityDestribution>
) => {
  const initialValues: FarmBoxCommodityDestribution =
    await getCommodityDistribution(Number(commodityId));
  const isRoutesPresent = initialValues?.routes?.length;
  return initialValues
    ? !isRoutesPresent
      ? { ...initialValues, routes: [new EndMarketLocations()] }
      : initialValues
    : new FarmBoxCommodityDestribution();
};
